export const PM_NOTIFICATION_LOAD = 'PM_NOTIFICATION_LOAD'
export const PM_NOTIFICATION_LOAD_PENDING = 'PM_NOTIFICATION_LOAD_PENDING'
export const PM_NOTIFICATION_LOAD_FULFILLED = 'PM_NOTIFICATION_LOAD_FULFILLED'
export const PM_NOTIFICATION_LOAD_REJECTED = 'PM_NOTIFICATION_LOAD_REJECTED'

export const PM_NOTIFICATION_MARK_AS_READ = 'PM_NOTIFICATION_MARK_AS_READ'
export const PM_NOTIFICATION_MARK_AS_READ_PENDING = 'PM_NOTIFICATION_MARK_AS_READ_PENDING'
export const PM_NOTIFICATION_MARK_AS_READ_FULFILLED = 'PM_NOTIFICATION_MARK_AS_READ_FULFILLED'
export const PM_NOTIFICATION_MARK_AS_READ_REJECTED = 'PM_NOTIFICATION_MARK_AS_READ_REJECTED'
